import { Component, OnInit, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective, AbstractControl } from '@angular/forms';
import { MultiLangPipe } from '../../../pipes/multi-lang.pipe';


@Component({
  selector: 'app-form-input',
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class FormInputComponent implements OnInit {

  @Input() public config: {
    name: string,
    label: string | Array<{languageCode: string, value: string}>,
    type: string,
    placeholder?: string,
    required?: boolean
  };
  pattern;
  placeholder;

  constructor(private formGroupDir: FormGroupDirective,
              private multiLangPipe: MultiLangPipe) { }

  /**
   * [get form control]
   * @author - Lalitkumar Saindane
   * @task - QLIKTAG-3377
   */
  get control(): AbstractControl {
    return this.formGroupDir.form.get(this.config.name);
  }

  /**
   * [setting pattern and placeholder]
   * @author - Lalitkumar Saindane
   * @task - QLIKTAG-3377
   */
  ngOnInit() {
    if (this.config.hasOwnProperty('type')) {
      if (this.config.type === 'email') {
        this.pattern =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      }
      if (this.config.type === 'url') {
        this.pattern = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
      }
    }

    if (this.config.hasOwnProperty('placeholder') && this.config.placeholder.length > 0) {
      this.placeholder = this.multiLangPipe.transform(this.config.placeholder);
    }
  }

}
